<obg-m-verification-code-header
	[icon]="iconDetails$ | async"
	[title]="headerTitle$ | async | translate"
></obg-m-verification-code-header>

<form [formGroup]="otpForm" class="obg-m-verification-code-form" (submit)="verify()">
	<div
		class="obg-m-verification-code-body"
		test-id="verification-code-container"
		data-test-id="verification-code-container"
	>
		<div class="obg-m-verification-code-change">
			<span [innerHtml]="verificationCodeKey | translate: { contact: customerContactInfo$ | async }"></span>
		</div>

		<obg-verification-code
			class="obg-m-verification-code-otp"
			formControlName="otp"
			(enterPress)="submitWithEnter()"
			(complete)="focusSubmitButtonOnNextTick()"
			(incomplete)="setCodeIncomplete()"
			(blur)="trackVerificationCodeChange()"
		>
			<ng-container messages>
				<mat-error
					*ngIf="errorMessage$ | async as errorMessage; else alertMessage"
					class="obg-m-verification-code-otp-error"
				>
					<ng-container *ngIf="errorMessage.genericMessage && !(isLoading$ | async)">
						<p [innerHtml]="errorMessage.genericMessage | translate"></p>
						<p
							data-test-id="two-factor-auth-dialog-otp-error-message"
							test-id="two-factor-auth-dialog-otp-error-message"
						>
							<span
								*ngIf="showVerificationAttempts"
								data-test-id="two-factor-auth-dialog-login-attempt-available"
								test-id="two-factor-auth-login-dialog-login-attempt-available"
							>
								{{ "two-factor-auth.dialog.attempt-message.pre" | translate }}
								{{ verificationAttemptAvailable }}
							</span>
						</p>
					</ng-container>

					<ng-container *ngIf="errorMessage.customMessage && !(isLoading$ | async)">
						<mat-error class="obg-m-verification-code-custom-error">
							<obg-m-customer-service-link
								[messageKey]="errorMessage.customMessage"
								(customerSupportClick)="customerSupportOnClick()"
							>
							</obg-m-customer-service-link>
						</mat-error>
					</ng-container>
				</mat-error>
				<ng-template #alertMessage>
					<div
						class="obg-m-verification-code-alert-message"
						data-test-id="two-factor-auth-dialog-otp-alert-message"
						test-id="two-factor-auth-dialog-otp-alert-message"
					>
						<span *ngIf="showVerificationAttempts">
							{{ "two-factor-auth.dialog.attempt-message.pre" | translate }}
							{{ verificationAttemptAvailable }}
						</span>
					</div>
				</ng-template>
			</ng-container>
		</obg-verification-code>
	</div>

	<div class="obg-m-verification-code-actions">
		<div class="obg-m-verification-code-actions-container">
			<ng-container *ngIf="showResendButtonAndCounter$ | async">
				<div class="obg-m-verification-code-actions-resend-code">
					<ng-container *ngIf="isRetryEnabled$ | async; else resendInfo">
						<div class="obg-m-verification-code-actions-resend-code-container">
							<div class="obg-m-verification-code-actions-resend-code-action">
								<p test-id="two-factor-auth-resend-text">
									{{ "two-factor-auth.dialog.customer-resend-text" | translate }}
								</p>
								&nbsp;
								<ng-container *ngIf="!(isLoading$ | async); else showPlainText">
									<a
										test-id="two-factor-auth-resend-btn"
										data-test-id="two-factor-auth-resend-btn"
										(click)="onResendCodeButtonClicked()"
									>
										{{ "two-factor-auth.dialog.resend-btn" | translate }}
									</a>
								</ng-container>
								<ng-template #showPlainText>
									<p class="obg-m-verification-code-resend-disabled">
										{{ "two-factor-auth.dialog.resend-btn" | translate }}
									</p>
								</ng-template>
							</div>
							<ng-container *ngIf="(retryCount$ | async) > 5">
								<span class="error">{{ "two-factor-auth.dialog.code-limit-reached" | translate }}</span>
								<obg-m-customer-service-link
									(customerSupportClick)="customerSupportOnClick()"
								></obg-m-customer-service-link>
							</ng-container>
						</div>
					</ng-container>
					<ng-template #resendInfo>
						<div
							[style.visibility]="(isLoading$ | async) ? 'hidden' : 'visible'"
							class="obg-m-verification-code-actions-resend-info"
						>
							{{ "two-factor-auth.dialog.resend-info" | translate }}
							{{ timer$ | async }}
							{{ "two-factor-auth.dialog.resend-info-seconds" | translate }}
						</div>
					</ng-template>
				</div>
			</ng-container>

			<div *ngIf="isLoginFlow && !hideRememberDevice" class="obg-m-verification-code-actions-remember-device">
				<mat-checkbox
					test-id="two-factor-auth-dialog-remember-device"
					data-test-id="two-factor-auth-dialog-remember-device"
					color="primary"
					[formControl]="otpForm.controls.rememberDevice"
					(change)="onRememberDeviceChanged($event)"
				>
					{{ "two-factor-auth.dialog.remember-device" | translate }}
				</mat-checkbox>
			</div>
		</div>

		<div class="obg-m-verification-code-actions-verify">
			<button
				#submitButton
				mat-flat-button
				color="accent"
				[disabled]="isSubmitButtonDisabled || (isVerifyButtonDisabled$ | async)"
				data-test-id="two-factor-auth.dialog.verify-btn"
				test-id="two-factor-auth.dialog.verify-btn"
			>
				<span *ngIf="!(isLoading$ | async); else showLoadingSpinner">
					{{ buttonText$ | async | translate }}
				</span>
				<ng-template #showLoadingSpinner>
					<mat-spinner diameter="20"></mat-spinner>
				</ng-template>
			</button>
		</div>
	</div>
</form>

<button
	*ngIf="!disableOtpMethodSwitching && showChangeMethodButton$ | async"
	class="obg-m-verification-code-change-method-btn"
	test-id="two-factor-auth-dialog-change-method-btn"
	data-test-id="two-factor-auth-dialog-change-method-btn"
	(click)="onChangeMethodClick()"
	[disabled]="isChangeMethodButtonDisabled$ | async"
>
	{{ changeMethodText$ | async | translate }}
</button>
